export default __webpack_public_path__ + "static/media/potion_04.57d81cd5.png";